import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { AuthService } from "../services/auth.service";
import { tap, concatMap, catchError } from "rxjs/operators";
import { LoggingService } from "../services/logging.service";
import { AppConfigService } from "../services/app-config.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private appConfigService: AppConfigService) {
    LoggingService.log("AuthInterceptor ctor");
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    LoggingService.log(`AuthInterceptor intercept - ${request.url}`);

    if (!this.shouldAuthorize(request.url)) {
      LoggingService.log("AuthInterceptor skipping authorization");
      return next.handle(request);
    }

    return this.authService.acquireTokenSilent$().pipe(
      tap(auth => {
        if (request.url.startsWith("http") && auth && auth.accessToken) {
          LoggingService.log("AuthInterceptor bearering");
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${auth.accessToken}`,
            },
          });
        }
      }),
      catchError(error => {
        LoggingService.log(`AuthInterceptor error - ${JSON.stringify(error)}`);
        return of(null);
      }),
      concatMap(() => {
        LoggingService.log("AuthInterceptor next.handle");
        return next.handle(request);
      }),
    );
  }

  private shouldAuthorize(url: string): boolean {
    const config = this.appConfigService.getConfig();

    return config && url && url.startsWith(config.baseApiUrl);
  }
}
